import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import "../styles/Unit.css";
import * as BsIcons from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import {
  getActiveBatch,
  getMovingActiveBatch,
  getInternalActiveBatch,
} from "../api_folder/api";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

function UnitSMPIT1() {
  const nav = useNavigate();

  const submitRegulerQ = (e) => {
    let unitSMPITQ = { id_batch: 89, name_unit: "SMPIT Quran Asy-Syukriyyah" };
    e.preventDefault();
    nav("/register-reguler", { state: unitSMPITQ });
  };

  const submitMovingQ = (e) => {
    let unitSMPITQ = {
      id_batch: 103,
      name_unit: "Pindahan SMPIT Quran Asy-Syukriyyah",
    };
    e.preventDefault();
    nav("/register-pindahan", { state: unitSMPITQ });
  };

  const [reg, setReg] = useState([]);
  const [inter, setInter] = useState([]);
  const [moving, setMoving] = useState([]);

  useEffect(() => {
    getActiveBatch().then((res) => {
      setReg(res.data);
    });
    getInternalActiveBatch().then((res) => {
      setInter(res.data);
    });
    getMovingActiveBatch().then((res) => {
      setMoving(res.data);
    });
  }, []);

  let aReg = [];
  let iReg = [];
  let mReg = [];
  if (reg.status !== "fail") {
    reg.forEach((qw) => {
      aReg.push(qw.name_unit);
    });
  }
  if (inter.status !== "fail") {
    inter.forEach((we) => {
      iReg.push(we.name_unit);
    });
  }

  if (moving.status !== "fail") {
    moving.forEach((wq) => {
      mReg.push(wq.name_unit);
    });
  }

  return (
    <section>
      <Navbar expand="sm" variant="custom" bsPrefix={""} sticky="top">
        <Navbar.Brand>
          <img
            src="/images/logo.svg"
            width="44"
            height="45"
            className="d-inline-block align-top ms-3"
            alt="logo"
          />
        </Navbar.Brand>
        <Nav>
          <Nav.Link>SPMB Asy-Syukriyyah Islamic School</Nav.Link>
        </Nav>
      </Navbar>
      <Container className="p-3 p-md-5">
        <Link to="/" className="back">
          <BsIcons.BsArrowLeftShort /> Kembali ke halaman utama
        </Link>
        <span className="circlexunit" />
        <span className="circleyunit" />

        <Row className="mt-5 px-1">
          <Col md={12} lg={8} className="d-flex flex-column gap-3">
            <div>
              <div style={{ color: "#12b795" }}>
                <h1 style={{ color: "#364152" }}>SMPIT Quran Asy-Syukriyyah</h1>
              </div>
              <p className="text-body-regsuccess">
                Pendaftaran peserta didik SMPIT Quran Asy-Syukriyyah
              </p>
              <hr />
              <div style={{ color: "#364152" }}>
                <h4 style={{ marginTop: "64px" }}>
                  Persyaratan Pendaftaran SMPIT Quran Asy-Syukriyyah
                </h4>
                <p className="text-body-unitsuccess">
                  Apa saja yang akan diperlukan untuk mendaftarkan peserta didik
                  baru.
                </p>
              </div>
            </div>
            <div className="infoBox listColored">
              <h6 style={{ color: "#364152" }}>📝 Persyaratan umum</h6>
              <ul>
                <li>
                  Melakukan pendaftaran secara online di alamat{" "}
                  <Link
                    style={{ color: "#12b795" }}
                    to="https://spmb.asy-syukriyyah.sch.id/"
                  >
                    spmb.asy-syukriyyah.sch.id
                  </Link>
                </li>
                <li>Mengikuti seleksi observasi dan wawancara orang tua</li>
                <li>Melengkapi berkas dokumen</li>
                <li>
                  Melunasi administrasi keuangan sampai waktu yang ditentukan
                </li>
              </ul>
            </div>
            <div className="infoBox listColored">
              <h6 style={{ color: "#364152" }}>📑 Persyaratan Dokumen</h6>
              <p>Dokumen dilampirkan pada saat tes masuk/observasi:</p>
              <ul>
                <li>Print out Formulir Pendaftaran Online</li>
                <li>Print out Kartu Tes/Observasi</li>
                <li>Foto copy akte kelahiran</li>
                <li>Foto copy KTP orang tua</li>
                <li>Foto copy kartu keluarga</li>
                <li>Surat keterangan NISN dari sekolah asal</li>
                <li>Pas foto 3x4 sebanyak 2 lembar</li>
                <li>Print out MoU yang dapat di download di halaman login</li>
                <li>Materai tempel 10.000</li>
              </ul>
            </div>
            <div className="infoBox listColored">
              <h6 style={{ color: "#364152" }}>🗒️ Materi Tes Masuk</h6>
              <p>
                <b>Akademik</b>
              </p>
              <ul>
                <li>Matematika</li>
                <li>IPA</li>
                <li>Bahasa Indonesia</li>
              </ul>
              <p>
                <b>Non-Akademik</b>
              </p>
              <ul>
                <li>Membaca Al-</li>
                <li>Psikotes</li>
              </ul>
              <p>
                <b>Wawancara orang tua atau wali</b>
              </p>
              <ul>
                <li>Kedua orang tua wajib hadir</li>
              </ul>
            </div>
            <div className="">
              <Row className="gap-4 p-3">
                <Col xs={12} className="infoBox">
                  <h6 style={{ color: "#364152" }}>📝 Ketentuan umum</h6>
                  <ul>
                    <li>
                      Masing-masing pendaftar akan mendapatkan nomor
                      pendaftaran.
                    </li>
                    <li>
                      Pembayaran biaya pendaftaran dilakukan melalui portal IDN
                      (infradigital).
                    </li>
                    <li>
                      Biaya pendaftaran sebagaimana tertera pada bukti
                      pendaftaran ditambah biaya admin.
                    </li>
                    <li>
                      Pembayaran biaya pendaftaran paling lambat 1 hari
                      terhitung dari hari pendaftaran.
                    </li>
                  </ul>
                </Col>
                <Col xs={12} className="infoBox">
                  <h6 style={{ color: "#364152" }}>
                    📄 Langkah-langkah pembayaran formulir registrasi reguler
                  </h6>
                  <ol>
                    <li>
                      Cek tagihan biaya formulir anda di{" "}
                      <Link
                        to={"https://www.infradigital.io/bills"}
                        style={{ color: "#12b795" }}
                      >
                        https://www.infradigital.io/bills
                      </Link>
                    </li>
                    <li>
                      Pilih unit pendidikan di kolom <b>“-Pilih Sekolah-”</b>
                    </li>
                    <li>
                      Masukkan nomor pendaftaran di kolom{" "}
                      <b>“Masukkan Nomor Induk Siswa (NIS)”</b>
                    </li>
                    <li>
                      Klik tombol <b>“Lihat Tagihan”</b>
                    </li>
                    <li>
                      Pastikan nominal tagihan dan nomor pendaftaran sudah
                      sesuai (ada tambahan biaya admin tergantung pilihan
                      pembayaran yg dipilih)
                    </li>
                    <li>
                      Pilih <b>“Cara bayar yang Anda kehendaki”</b>
                    </li>
                    <li>
                      Klik <b>"Lihat Cara Bayar"</b>
                    </li>
                    <li>
                      Ikuti petunjuk pembayaran sesuai yang tertera di{" "}
                      <Link
                        to={"https://www.infradigital.io/bills"}
                        style={{ color: "#12b795" }}
                      >
                        infradigital.io
                      </Link>
                    </li>
                    <li>
                      Konfirmasikan pembayaran biaya pendaftaran anda ke Call
                      Center unit pendidikan terkait untuk aktivasi akun.
                    </li>
                  </ol>
                </Col>
                <Col xs={12} className="infoBox">
                  <h6 style={{ color: "#364152" }}>📅 Kode unit pendidikan</h6>
                  <ul>
                    <li>
                      <span className="primColor">10620</span> - TK Islam
                      Terpadu Asy-Syukriyyah
                    </li>
                    <li>
                      <span className="primColor">10610</span> - MI Plus
                      Asy-Syukriyyah
                    </li>
                    <li>
                      <span className="primColor">10619</span> - SD Islam
                      Terpadu Asy-Syukriyyah
                    </li>
                    <li>
                      <span className="primColor">216948</span> - SDIT Quran
                      Asy-Syukriyyah Faturrahman
                    </li>
                    <li>
                      <span className="primColor">10622</span> - SMP Islam
                      Terpadu Asy-Syukriyyah
                    </li>
                    <li>
                      <span className="primColor">10623</span> - MTs Plus
                      Asy-Syukriyyah
                    </li>
                    <li>
                      <span className="primColor">10621</span> - SMA Islam
                      Terpadu Asy-Syukriyyah
                    </li>
                  </ul>
                </Col>
              </Row>
            </div>
          </Col>
          <Col md={"auto"} lg={2} xxl={3} className="mt-3">
            <Row className="row-cols-1 row-cols-md-2 row-cols-lg-1">
              <Col>
                <Card className="cardUnit  mx-auto mx-lg-0 ">
                  <Card.Img
                    variant="top"
                    src="/images/imgsmpit.png"
                    alt="Temporary Image"
                    style={{
                      height: "220px",
                      objectFit: "contain",
                    }}
                    className="img-fluid"
                  />
                  <Card.Body>
                    <Card.Title>SMPIT Quran Asy-Syukriyyah</Card.Title>
                    <Card.Text>
                      <span>Pendaftaran dibuka pada</span>{" "}
                      <span style={{ color: "#12b795" }}>2 Oktober 2026</span>
                    </Card.Text>
                    
                    {/* SMPIT Quran Reguler */}
                    {aReg.includes("SMPIT Quran Asy-Syukriyyah") ? (
                      <Form onSubmit={submitRegulerQ}>
                        <Button
                          variant="unit"
                          className="rounded-pill mt-3"
                          type="submit"
                        >
                          Pendaftaran Eksternal
                        </Button>
                      </Form>
                    ) : (
                      <Button
                        variant="unitClosed"
                        className="rounded-pill mt-3"
                      >
                        Pendaftaran Reguler
                      </Button>
                    )}
                    {/* SMPIT Quran Internal */}
                    {iReg.includes("SMPIT Quran Asy-Syukriyyah") ? (
                      <Link to="/register-internal">
                        <Button
                          variant="unit"
                          className="rounded-pill mt-3"
                          type="submit"
                        >
                          Pendaftaran Internal
                        </Button>
                      </Link>
                    ) : (
                      <Button
                        variant="unitClosed"
                        className="rounded-pill mt-3"
                      >
                        Pendaftaran Internal
                      </Button>
                    )}
                    {/* SMPIT Quran Pindahan */}
                    {mReg.includes("SMPIT Quran Asy-Syukriyyah") ? (
                      <Form onSubmit={submitMovingQ}>
                        <Button
                          variant="unit"
                          className="rounded-pill mt-3"
                          type="submit"
                        >
                          Pendaftaran Pindahan 
                        </Button>
                      </Form>
                    ) : (
                      <Button
                        variant="unitClosed"
                        className="rounded-pill mt-3"
                      >
                        Pendaftaran Pindahan
                      </Button>
                    )}
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card
                  style={{ marginTop: "1rem" }}
                  className="cardUnit  mx-auto mx-0-lg"
                >
                  <Card.Body>
                    <Card.Title
                      style={{ color: "#12b795", textAlign: "center" }}
                    >
                      Kontak SMPIT Quran Asy-Syukriyyah
                    </Card.Title>
                    <Card.Text
                      className="text-center"
                      style={{ color: "#697586" }}
                    >
                      Email: astaqu@asy-syukriyyah.sch.id
                    </Card.Text>
                    <Button
                      target="_blank"
                      variant="success"
                      className="rounded-pill mt-3"
                      href="https://wa.me/+6282118663423"
                    >
                      WhatsApp
                    </Button>
                  </Card.Body>
                </Card>
                <Card
                  style={{ marginTop: "1rem" }}
                  className="cardUnit  mx-auto mx-0-lg"
                >
                  <Card.Body>
                    <Card.Title
                      style={{ color: "#12b795", textAlign: "center" }}
                    >
                      Brosur SMPIT Quran Asy-Syukriyyah
                    </Card.Title>
                    <Card.Text
                      className="text-center"
                      style={{ color: "#697586" }}
                    >
                      Untuk informasi selanjutnya silahkan download brosur
                      sekolah di bawah ini.
                    </Card.Text>
                    <Button
                      variant="success"
                      className="rounded-pill mt-3"
                      target="_blank"
                      href="https://spmb.asy-syukriyyah.sch.id/brosur/brosur-SMPIT-QURAN.pdf"
                    >
                      Download Brosur
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default UnitSMPIT1;
